import * as Yup from "yup";

export const serviceSchema = Yup.object().shape({
    nameService: Yup.string()
        .required("Campo obrigatório.")
        .max(100, "O nome deve ter no máximo 100 caracteres."),
    type: Yup.string().required("O tipo é obrigatório."),
    value: Yup.number()
        .typeError("Valor deve ser um número.")
        .min(0, "O valor não pode ser negativo.")
        .required("Campo obrigatório."),
    maxAmountInstallments: Yup.number()
        .typeError("Deve ser número.")
        .min(1, "O mínimo é 1.")
        .required("Campo obrigatório."),
    stock: Yup.number().typeError("Deve ser um número.").min(0, "Estoque não pode ser negativo"),
    costPrice: Yup.number().typeError("Deve ser um número.").min(0, "Custo não pode ser negativo"),
    minimumStock: Yup.number().typeError("Deve ser um número.").min(0, "Estoque não pode ser negativo")
});

/**
 * Prepara o objeto para ser salvo no Firestore
 */
